<template>
  <div class="flex column" style="width: 100vm" v-title data-title="关于闯关">
    <div v-for="(data, index) in list" :key="index">
      <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
        <div class="flex main-space-between cross-center" style="height: 49px;">
          <span>{{index + 1}}.{{data.title}}</span>
          <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
        </div>
        <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutPass",
    data () {
      return{
        list: [
          {
            title: '闯关规则是什么？',
            detailTexts: [{title: '该规则中的奖励阅芽仅适用于阅伴学生端，教师端闯关不奖励阅芽。', img: require('../assets/pass_rule.png')}]
          },
          {
            title: '阅芽是什么？',
            detailTexts: [{title: '阅芽是阅伴App的积分，可累积可消耗，阅芽数量越多，说明孩子阅读越认真。'}]
          },
          {
            title: '如何获得阅芽',
            detailTexts: [{title: '注册赠送：教师注册并认证成功即赠送500片阅芽。'},
              {title: '购书获得：在阅伴官方书店购书，确认收货后兑换获得。'},
              {title: '邀请教师赠送：在“阅伴教师端App-首页-邀请教师”将活动页面分享给其他教师，在活动期间，每邀请一名教师注册并认证成功奖励100片阅芽。'}]
          },
          {
            title: '阅芽有哪些用途？',
            detailTexts: [{title: '赠送学生：当自己班级的学生阅芽用完了，不能重复闯关时，老师可以向学生赠送阅芽。'},
              {title: '兑换课程：在“教师服务中心-兑换课程”中可消耗一定的阅芽兑换视频课程。'},
              {title: '兑换课件：在“教师服务中心-兑换课件”中可通过消耗一定的阅芽，获取课件的原件（课件主要是方便老师们开展班级阅读使用）。'}]
          },
          {
            title: '如何查看错题，为什么有的时候不能查看错题？',
            detailTexts: [{title: '答题完成，点击提交后，显示闯关成功但未获得满分时，有查看错题按钮，点击即可查看错题。'},
              {title: '如果此关卡闯关失败，则无法查看错题'}]
          },
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutPass.vue